import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule, PreloadAllModules} from '@angular/router';


//Material Design Css import
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule} from '@angular/material';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UserComponent } from './ultilities/user/user.component';
import { SettingComponent } from './ultilities/setting/setting.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims/claims.component';
import { OfficeGridComponent } from './master/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './master/office/office-form/office-form.component';
import { OfficeComponent } from './master/office/office.component';
import { MasterComponent } from './master/master.component';
import { AllocationComponent } from './allocation/allocation.component';
import { MasterMenuComponent } from './master/master-menu/master-menu.component';
import { ApplicationformComponent } from './allocation/forms/applicationform/applicationform.component';
import { ApplicationMenuComponent } from './allocation/application-menu/application-menu.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import {NgxPaginationModule} from 'ngx-pagination';
import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { GridComponent } from './allocation/khbnotification/grid/grid.component';
import { FormComponent } from './allocation/khbnotification/form/form.component';
import { PrAllotmentGridComponent } from './allocation/pr-allotment/pr-allotment-grid/pr-allotment-grid.component';
import { PrAllotmentFormComponent } from './allocation/pr-allotment/pr-allotment-form/pr-allotment-form.component';
import { PrAllotmentNotsentComponent } from './allocation/pr-allotment/pr-allotment-notsent/pr-allotment-notsent.component';
import { PropertyregisterGridComponent } from './allocation/property-register/propertyregister-grid/propertyregister-grid.component';
import { PropertyregisterFormComponent } from './allocation/property-register/propertyregister-form/propertyregister-form.component';
import { SmsGridComponent } from './allocation/smsby-location/sms-grid/sms-grid.component';
import { SmsFormComponent } from './allocation/smsby-location/sms-form/sms-form.component';
import { CampaignDetailsComponent } from './allocation/smsby-location/campaign-details/campaign-details.component';
import { WebsitenewsGridComponent } from './allocation/website-news/websitenews-grid/websitenews-grid.component';
import { WebsitenewsFormComponent } from './allocation/website-news/websitenews-form/websitenews-form.component';
import { ApplicantComponent } from './applicant/applicant.component';
import { ProfileComponent } from './applicant/profile/profile.component';
import { ActivelistComponent } from './applicant/apply/activelist/activelist.component';
import { ApplicationstatusComponent } from './applicant/applicationstatus/applicationstatus.component';
import { ApplicationViewComponent } from './applicant/application-view/application-view.component';
import { ApplicantMenuComponent } from './applicant/applicant-menu/applicant-menu.component';
import { PaymentComponent } from './applicant/payment/payment.component';
import { ScrutinyComponent } from './allocation/scrutiny/scrutiny.component';
import { LotteryComponent } from './allocation/lottery/lottery.component';
import { AllottmentListComponent } from './allocation/allottment-list/allottment-list.component';
import { NotAllotedListComponent } from './allocation/not-alloted-list/not-alloted-list.component';
import { InstallmentconfigComponent } from './allocation/installmentconfig/installmentconfig.component';
import { AllotmentCancellationComponent } from './allocation/allotment-cancellation/allotment-cancellation.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';

import { FinanceComponent } from './finance/finance.component';
import { PaymentConfigComponent } from './finance/payment-config/payment-config.component';
import { RefundComponent } from './finance/refund/refund.component';
import { FinanceMenuComponent } from './finance/finance-menu/finance-menu.component';
import { ChangeAddressComponent } from './applicant/change-address/change-address.component';
import { RefundRequestComponent } from './applicant/refund-request/refund-request.component';
import { NotAllotedRefundComponent } from './allocation/not-alloted-refund/not-alloted-refund.component';
import { RefundlistComponent } from './finance/refundlist/refundlist.component';
import { LocationStrategy, HashLocationStrategy, TitleCasePipe } from '@angular/common';
import { ProjectMasterComponent } from './master/project-master/project-master.component';
import { ReAllotmentComponent } from './allocation/re-allotment/re-allotment.component';
import { PrintAllotmentletterComponent } from './allocation/print-allotmentletter/print-allotmentletter.component';
import { ChangePropertyComponent } from './allocation/change-property/change-property.component';
import { WaitingListComponent } from './allocation/waiting-list/waiting-list.component';
import { DefaultersComponent } from './allocation/defaulters/defaulters.component';

import { EKhataComponent } from './allocation/e-khata/e-khata.component';
import { ProjectmasterFormComponent } from './master/project-master/projectmaster-form/projectmaster-form.component';
import { ProjectmasterGridComponent } from './master/project-master/projectmaster-grid/projectmaster-grid.component';
import { ChangePropertygridComponent } from './allocation/change-property/change-propertygrid/change-propertygrid.component';
import { ChangePropertyformComponent } from './allocation/change-property/change-propertyform/change-propertyform.component';
import { InstallmentDueComponent } from './allocation/installment-due/installment-due.component';
import { ProvisionAllotmentComponent } from './allocation/provision-allotment/provision-allotment.component';
import { MaintainanceFeeComponent } from './allocation/maintainance-fee/maintainance-fee.component';
import { PlanningComponent } from './planning/planning.component';
import { PlanningMenuComponent } from './planning/planning-menu/planning-menu.component';

import { ProjectFormComponent } from './planning/project/project-form/project-form.component';
import { ProjectListComponent } from './planning/project/project-list/project-list.component';
import { LandRecordComponent } from './planning/land-record/land-record.component';
import { LandrecordformComponent } from './planning/land-record/landrecordform/landrecordform.component';
import { LandrecordlistComponent } from './planning/land-record/landrecordlist/landrecordlist.component';
import { ValidatelandrecordlistComponent } from './planning/validatelandrecordlist/validatelandrecordlist.component';


import { PropertyPlanAlllistComponent } from './allocation/pr-allotment/property-plan-alllist/property-plan-alllist.component';
import { ConsultantComponent } from './planning/consultant/consultant.component';
import { StatutoryClearancesComponent } from './planning/statutory-clearances/statutory-clearances.component';
import { KhbDrawingComponent } from './planning/khb-drawing/khb-drawing.component';
import { ApprovedDrawingComponent } from './planning/approved-drawing/approved-drawing.component';
import { BuiltDrawingComponent } from './planning/built-drawing/built-drawing.component';
import { RevisedDrawingComponent } from './planning/revised-drawing/revised-drawing.component';
import { ConsultantFromComponent } from './planning/consultant/consultant-from/consultant-from.component';
import { ApprovedDrawingFormComponent } from './planning/approved-drawing/approved-drawing-form/approved-drawing-form.component';
import { BuiltDrawingFormComponent } from './planning/built-drawing/built-drawing-form/built-drawing-form.component';
import { KhbDrawingFormComponent } from './planning/khb-drawing/khb-drawing-form/khb-drawing-form.component';
import { RevisedDrawingFormComponent } from './planning/revised-drawing/revised-drawing-form/revised-drawing-form.component';
import { StatutoryClearancesFormComponent } from './planning/statutory-clearances/statutory-clearances-form/statutory-clearances-form.component';
import { StatutoryClearancesGridComponent } from './planning/statutory-clearances/statutory-clearances-grid/statutory-clearances-grid.component';
import { RevisedDrawingGridComponent } from './planning/revised-drawing/revised-drawing-grid/revised-drawing-grid.component';
import { KhbDrawingGridComponent } from './planning/khb-drawing/khb-drawing-grid/khb-drawing-grid.component';
import { BuiltDrawingGridComponent } from './planning/built-drawing/built-drawing-grid/built-drawing-grid.component';
import { ApprovedDrawingGridComponent } from './planning/approved-drawing/approved-drawing-grid/approved-drawing-grid.component';
import { ProjectNamesComponent } from './allocation/allotment-cancellation/project-names/project-names.component';
import { AllotmentProjectListComponent } from './allocation/allotment-cancellation/allotment-project-list/allotment-project-list.component';
import { AllotmentAllottedPropertyComponent } from './allocation/allotment-cancellation/allotment-allotted-property/allotment-allotted-property.component';
import { PaymentDetailsComponent } from './allocation/allotment-cancellation/payment-details/payment-details.component';
import { SaledeedDetailsComponent } from './allocation/allotment-cancellation/saledeed-details/saledeed-details.component';
import { CancelAllotmentComponent } from './allocation/allotment-cancellation/cancel-allotment/cancel-allotment.component';
import { SaleComponent } from './allocation/saledeed/sale/sale.component';
import { SoldpropertyComponent } from './allocation/saledeed/soldproperty/soldproperty.component';
import { PropertiesregisterComponent } from './planning/propertiesregister/propertiesregister.component';
import { PropertiesregisterFormComponent } from './planning/propertiesregister/propertiesregister-form/propertiesregister-form.component';
import { PropertiesregisterListComponent } from './planning/propertiesregister/propertiesregister-list/propertiesregister-list.component';
import { ConsultantListComponent } from './planning/consultant/consultant-list/consultant-list.component';
import { ScrutinyViewComponent } from './allocation/scrutiny-view/scrutiny-view.component';
import { ProvisionlistComponent } from './allocation/provisionlist/provisionlist.component';
import { FinalListComponent } from './allocation/final-list/final-list.component';
import { ProjectListsComponent } from './allocation/allotment-cancellation/project-list/project-list.component';
import { RevisedpropertyregisterComponent } from './planning/revisedpropertyregister/revisedpropertyregister.component';
import { RevisedpropertyregisterFormComponent } from './planning/revisedpropertyregister/revisedpropertyregister-form/revisedpropertyregister-form.component';
import { RevisedpropertyregisterGridComponent } from './planning/revisedpropertyregister/revisedpropertyregister-grid/revisedpropertyregister-grid.component';
import { ApplicationlistComponent } from './allocation/applicationlist/applicationlist.component';
import { PdfFormsComponent } from './pdf-forms/pdf-forms.component';
import { KhbnotificationComponent } from './pdf-forms/khbnotification/khbnotification.component';
import { LandprocurementComponent } from './landprocurement/landprocurement.component';
import { LandprocurementMenuComponent } from './landprocurement/landprocurement-menu/landprocurement-menu.component';
import { ViabilityGridComponent } from './landprocurement/viability-report/viability-grid/viability-grid.component';
import { ViabilityFormComponent } from './landprocurement/viability-report/viability-form/viability-form.component';
import { ProposalFormComponent } from './landprocurement/proposal-report/proposal-form/proposal-form.component';
import { ProposalGridComponent } from './landprocurement/proposal-report/proposal-grid/proposal-grid.component';
import { InspectionGridComponent } from './landprocurement/inspection-report/inspection-grid/inspection-grid.component';
import { InspectionFormComponent } from './landprocurement/inspection-report/inspection-form/inspection-form.component';
import { LanddetailsGridComponent } from './landprocurement/land-details/landdetails-grid/landdetails-grid.component';
import { LanddetailsFormComponent } from './landprocurement/land-details/landdetails-form/landdetails-form.component';
import { LandpaymentGridComponent } from './landprocurement/land-payment/landpayment-grid/landpayment-grid.component';
import { LandpaymentFormComponent } from './landprocurement/land-payment/landpayment-form/landpayment-form.component';
import { RateGridComponent } from './landprocurement/rate-fixation/rate-grid/rate-grid.component';
import { RateFormComponent } from './landprocurement/rate-fixation/rate-form/rate-form.component';
import { OnGridComponent } from './landprocurement/objectionnotification/on-grid/on-grid.component';
import { OnFormComponent } from './landprocurement/objectionnotification/on-form/on-form.component';
import { LegalMenuComponent } from './legal/legal-menu/legal-menu.component';
import { LegalComponent } from './legal/legal.component';
import { CpViewComponent } from './legal/case-proceeding/cp-view/cp-view.component';
import { CpFormComponent } from './legal/case-proceeding/cp-form/cp-form.component';
import { CrFormComponent } from './legal/case-registration/cr-form/cr-form.component';
import { CrViewComponent } from './legal/case-registration/cr-view/cr-view.component';
//import { AdvocatesViewComponent } from './master/advocates/advocates-view/advocates-view.component';
//import { AdvocatesFormComponent } from './master/advocates/advocates-form/advocates-form.component';
import { CourttypeFormComponent } from './master/court-type/courttype-form/courttype-form.component';
import { CourttypeViewComponent } from './master/court-type/courttype-view/courttype-view.component';
import { CourtViewComponent } from './master/court/court-view/court-view.component';
import { CourtFormComponent } from './master/court/court-form/court-form.component';
import { DeptFormComponent } from './master/department/dept-form/dept-form.component';
import { DeptViewComponent } from './master/department/dept-view/dept-view.component';
import { DistrictFormComponent } from './master/district/district-form/district-form.component';
import { DistrictViewComponent } from './master/district/district-view/district-view.component';
import { DemandSurveyDraftComponent } from './allocation/demand-survey-draft/demand-survey-draft.component';
import { IdNotificationDraftComponent } from './allocation/id-notification-draft/id-notification-draft.component';
import { LandrecFormComponent } from './landprocurement/land-rec-details/landrec-form/landrec-form.component';
import { LandrecGridComponent } from './landprocurement/land-rec-details/landrec-grid/landrec-grid.component';
import { LandRecDetailsComponent } from './landprocurement/land-rec-details/land-rec-details.component';
import { FooterComponent } from './common/footer/footer.component';
import { ELotteryComponent } from './allocation/e-lottery/e-lottery.component';
import { ManualGridComponent } from './allocation/manual-lottery/manual-grid/manual-grid.component';
import { ManualFormComponent } from './allocation/manual-lottery/manual-form/manual-form.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { PaymentConfigViewComponent } from './finance/payment-config-view/payment-config-view.component';
import { UserApplicationComponent } from './applicant/user-application/user-application.component';
import { ApplicantApplicationComponent } from './applicant/user-application/applicant-application/applicant-application.component';
import { ApplicantApplicationFormComponent } from './applicant/user-application/applicant-application-form/applicant-application-form.component';
import { khbChallanComponent } from './pdf-forms/khb-challan/khb-challan.component';
import { StatusviewComponent } from './applicant/status/statusview/statusview.component';
import { AppstatusComponent } from './applicant/appstatus/appstatus.component';
import { ApplicationinstallmentpayComponent } from './applicant/applicationinstallmentpay/applicationinstallmentpay.component';
import { ApplicationcancellationComponent } from './applicant/applicationcancellation/applicationcancellation.component';
import { ApplicationrefundComponent } from './applicant/applicationrefund/applicationrefund.component';
import { TransactionDetailsComponent } from './applicant/transaction-details/transaction-details.component';
import { TechnicalComponent } from './technical/technical.component';
import { FilemasterFormComponent } from './master/file-master/filemaster-form/filemaster-form.component';
import { FilemasterGridComponent } from './master/file-master/filemaster-grid/filemaster-grid.component';
import { CasetypeFormComponent } from './master/casetype/casetype-form/casetype-form.component';
import { CasetypeGridComponent } from './master/casetype/casetype-grid/casetype-grid.component';
import { FmFormComponent } from './legal/file-movement/fm-form/fm-form.component';
import { FmGridComponent } from './legal/file-movement/fm-grid/fm-grid.component';
import { CavFormComponent } from './legal/change-advocate/cav-form/cav-form.component';
import { CavGridComponent } from './legal/change-advocate/cav-grid/cav-grid.component';
import { QueryComponent } from './legal/query/query.component';
import { AdvPayFormComponent } from './legal/advocate-payment/adv-pay-form/adv-pay-form.component';
import { AdvPayGridComponent } from './legal/advocate-payment/adv-pay-grid/adv-pay-grid.component';
import { AdvocatesGridComponent } from './legal/advocates/advocates-grid/advocates-grid.component';
import { QcGridComponent } from './technical/qc/qc-grid/qc-grid.component';
import { QcFormComponent } from './technical/qc/qc-form/qc-form.component';
import { QcTypeFormComponent } from './technical/qc-type/qc-type-form/qc-type-form.component';
import { QcTypeGridComponent } from './technical/qc-type/qc-type-grid/qc-type-grid.component';
import { PescTypeFormComponent } from './technical/pe-sc-type/pesc-type-form/pesc-type-form.component';
import { PescTypeGridComponent } from './technical/pe-sc-type/pesc-type-grid/pesc-type-grid.component';
import { PescGridComponent } from './technical/pe-sc/pesc-grid/pesc-grid.component';
import { PescFormComponent } from './technical/pe-sc/pesc-form/pesc-form.component';
import { ProjectDesignIssueAllFormComponent } from './technical/project-design-issue-total/project-design-issue-all-form/project-design-issue-all-form.component';
import { ProjectDesignIssueAllGridComponent } from './technical/project-design-issue-total/project-design-issue-all-grid/project-design-issue-all-grid.component';
import { ProjectProgressFormComponent } from './technical/project-progress/project-progress-form/project-progress-form.component';
import { ProjectProgressGridComponent } from './technical/project-progress/project-progress-grid/project-progress-grid.component';
import { ScheduleExtensionFormComponent } from './technical/schedule-extension/schedule-extension-form/schedule-extension-form.component';
import { ScheduleExtensionGridComponent } from './technical/schedule-extension/schedule-extension-grid/schedule-extension-grid.component';
import { DesignIssueTypeFormComponent } from './technical/project-design-issue-type/design-issue-type-form/design-issue-type-form.component';
import { DesignIssueTypeGridComponent } from './technical/project-design-issue-type/design-issue-type-grid/design-issue-type-grid.component';
import { DesignIssueGridComponent } from './technical/project-design-issue/design-issue-grid/design-issue-grid.component';
import { DesignIssueFormComponent } from './technical/project-design-issue/design-issue-form/design-issue-form.component';
import { QuantumFormComponent } from './technical/encumbrances-quantum/quantum-form/quantum-form.component';
import { QuantumGridComponent } from './technical/encumbrances-quantum/quantum-grid/quantum-grid.component';
import { EncumbrancesGridComponent } from './technical/project-encumbrances/encumbrances-grid/encumbrances-grid.component';
import { EncumbrancesFormComponent } from './technical/project-encumbrances/encumbrances-form/encumbrances-form.component';
import { EncumbrancesTypeFormComponent } from './technical/project-encumbrances-type/encumbrances-type-form/encumbrances-type-form.component';
import { EncumbrancesTypeGridComponent } from './technical/project-encumbrances-type/encumbrances-type-grid/encumbrances-type-grid.component';
import { DocTypeFormComponent } from './technical/contractor-doc-type/doc-type-form/doc-type-form.component';
import { DocTypeGridComponent } from './technical/contractor-doc-type/doc-type-grid/doc-type-grid.component';
import { ContractordocFormComponent } from './technical/contractor-documents/contractordoc-form/contractordoc-form.component';
import { ContractordocGridComponent } from './technical/contractor-documents/contractordoc-grid/contractordoc-grid.component';
import { ContractorFormComponent } from './technical/contractor/contractor-form/contractor-form.component';
import { LandacquisitionFormComponent } from './landprocurement/land-acquisition/landacquisition-form/landacquisition-form.component';
import { LandacquisitionGridComponent } from './landprocurement/land-acquisition/landacquisition-grid/landacquisition-grid.component';
import { LandpurchaseFormComponent } from './landprocurement/land-purchase/landpurchase-form/landpurchase-form.component';
import { LandpurchaseGridComponent } from './landprocurement/land-purchase/landpurchase-grid/landpurchase-grid.component';
import { JobsViewComponent } from './technical/jobs/jobs-view/jobs-view.component';
import { StructuresViewComponent } from './technical/structures/structures-view/structures-view.component';
import { StructuresplanningFormComponent } from './technical/structures-planning/structuresplanning-form/structuresplanning-form.component';
import { StructuresplanningGridComponent } from './technical/structures-planning/structuresplanning-grid/structuresplanning-grid.component';
import { BoqitemGridComponent } from './technical/boq-item/boqitem-grid/boqitem-grid.component';
import { ContractorGridComponent } from './technical/contractor/contractor-grid/contractor-grid.component';
import { PhasescheduleGridComponent } from './technical/schedule/phaseschedule-grid/phaseschedule-grid.component';
import { PhasescheduleFormComponent } from './technical/schedule/phaseschedule-form/phaseschedule-form.component';
import { MilestoneGridComponent } from './technical/milestones/milestone-grid/milestone-grid.component';
import { MilestoneFormComponent } from './technical/milestones/milestone-form/milestone-form.component';
import { BoqitemFormComponent } from './technical/boq-item/boqitem-form/boqitem-form.component';
import { StructuresFormComponent } from './technical/structures/structures-form/structures-form.component';
import { JobsFormComponent } from './technical/jobs/jobs-form/jobs-form.component';
import { JobgroupFormComponent } from './technical/jobgroup/jobgroup-form/jobgroup-form.component';
import { JobgroupViewComponent } from './technical/jobgroup/jobgroup-view/jobgroup-view.component';
import { ActivityFormComponent } from './technical/project-activity/activity-form/activity-form.component';
import { ActivityGridComponent } from './technical/project-activity/activity-grid/activity-grid.component';
import { BoqFormComponent } from './technical/basline-boq/boq-form/boq-form.component';
import { BoqGridComponent } from './technical/basline-boq/boq-grid/boq-grid.component';
import { TechnicalMenuComponent } from './technical/technical-menu/technical-menu.component';
import { EquipmentFormComponent } from './technical/equipment/equipment-form/equipment-form.component';
import { EquipmentGridComponent } from './technical/equipment/equipment-grid/equipment-grid.component';
import { StaffGridComponent } from './technical/staff/staff-grid/staff-grid.component';
import { StaffFormComponent } from './technical/staff/staff-form/staff-form.component';
import { TenderFormComponent } from './technical/tender/tender-form/tender-form.component';
import { TenderGridComponent } from './technical/tender/tender-grid/tender-grid.component';
import { auctionintimationComponent } from './pdf-forms/auctionintimation/auctionintimation.component';
import { auctionnotificationComponent } from './pdf-forms/auctionnotification/auctionnotification.component';
import { NotAllotedRefundFormComponent } from './allocation/not-alloted-refund-form/not-alloted-refund-form.component';
import { KhbInstachallanComponent } from './pdf-forms/khb-instachallan/khb-instachallan.component';
import { LotteryApplicantViewComponent } from './allocation/lottery/lottery-applicant-view/lottery-applicant-view.component';

//HRMS Imports starts
// import { DeputationOutGridComponent } from './hrms/transfer/deputation-out/deputation-out-grid/deputation-out-grid.component';
// import { DeputationOutFormComponent } from './hrms/transfer/deputation-out/deputation-out-form/deputation-out-form.component';
import { AttendanceDetailsGridComponent } from './hrms/payroll/attendance-details/attendance-details-grid/attendance-details-grid.component';
import { DeductionDetailsGridComponent } from './hrms/payroll/deduction-details/deduction-details-grid/deduction-details-grid.component';
import { DeductionDetailsFormComponent } from './hrms/payroll/deduction-details/deduction-details-form/deduction-details-form.component';
import { InsuranceDetailsGridComponent } from './hrms/payroll/insurance-details/insurance-details-grid/insurance-details-grid.component';
import { TransferInGridComponent } from './hrms/transfer/transfer-in/transfer-in-grid/transfer-in-grid.component';
import { TransferInFormComponent } from './hrms/transfer/transfer-in/transfer-in-form/transfer-in-form.component';
import { AttendanceDetailsFormComponent } from './hrms/payroll/attendance-details/attendance-details-form/attendance-details-form.component';
import { TransferOutFormComponent } from './hrms/transfer/transfer-out/transfer-out-form/transfer-out-form.component';
import { TransferOutGridComponent } from './hrms/transfer/transfer-out/transfer-out-grid/transfer-out-grid.component';
// import { DeputationInFormComponent } from './hrms/transfer/deputation-in/deputation-in-form/deputation-in-form.component';
// import { DeputationInGridComponent } from './hrms/transfer/deputation-in/deputation-in-grid/deputation-in-grid.component';
import { InsuranceDetailsFormComponent } from './hrms/payroll/insurance-details/insurance-details-form/insurance-details-form.component';
// import { TrainingDetailsGridComponent } from './hrms/serviceregister/training-details/training-details-grid/training-details-grid.component';
// import { TrainingDetailsFormComponent } from './hrms/serviceregister/training-details/training-details-form/training-details-form.component';
// import { DepartmentalExamDetailsFormComponent } from './hrms/serviceregister/departmental-exam-details/departmental-exam-details-form/departmental-exam-details-form.component';
// import { HtcLtcGridComponent } from './hrms/serviceregister/htc-ltc/htc-ltc-grid/htc-ltc-grid.component';
// import { HtcLtcFormComponent } from './hrms/serviceregister/htc-ltc/htc-ltc-form/htc-ltc-form.component';
import { BankDetailsGridComponent } from './hrms/serviceregister/bank-details/bank-details-grid/bank-details-grid.component';
import { HrmsMenuComponent } from './hrms/hrms-menu/hrms-menu.component';
import { ServiceregisterComponent } from './hrms/serviceregister/serviceregister.component';
import { PayrollComponent } from './hrms/payroll/payroll.component';
import { AllowancesDetailsGridComponent } from './hrms/payroll/allowances-details/allowances-details-grid/allowances-details-grid.component';
import { AllowancesDetailsFormComponent } from './hrms/payroll/allowances-details/allowances-details-form/allowances-details-form.component';
// import { DepartmentalExamDetailsGridComponent } from './hrms/serviceregister/departmental-exam-details/departmental-exam-details-grid/departmental-exam-details-grid.component';
import { BankDetailsFormComponent } from './hrms/serviceregister/bank-details/bank-details-form/bank-details-form.component';
import { HrmsComponent } from './hrms/hrms.component';
import { CasteGridComponent } from './master/caste/caste-grid/caste-grid.component';
import { CasteFormComponent } from './master/caste/caste-form/caste-form.component';
import { DesignationGridComponent } from './master/designations/designation-grid/designation-grid.component';
import { DesignationFormComponent } from './master/designations/designation-form/designation-form.component';
import { ReligionGridComponent } from './master/religion/religion-grid/religion-grid.component';
import { LeavesFormComponent } from './master/leaves/leaves-form/leaves-form.component';
import { UserprofileGridComponent } from './master/userprofile/userprofile-grid/userprofile-grid.component';
import { HolidaycalendarGridComponent } from './master/holidaycalendar/holidaycalendar-grid/holidaycalendar-grid.component';
import { UserprofileFormComponent } from './master/userprofile/userprofile-form/userprofile-form.component';
import { HolidaycalendarFormComponent } from './master/holidaycalendar/holidaycalendar-form/holidaycalendar-form.component';
import { EmpBasicDetailGridComponent } from './hrms/serviceregister/employee-basic-details/emp-basic-detail-grid/emp-basic-detail-grid.component';
import { DependentGridComponent } from './hrms/serviceregister/dependent-details/dependent-grid/dependent-grid.component';
import { DependentFormComponent } from './hrms/serviceregister/dependent-details/dependent-form/dependent-form.component';
import { QualificationInputGridComponent } from './hrms/serviceregister/qualification-input/qualification-input-grid/qualification-input-grid.component';
import { LeaveDetailsFormComponent } from './hrms/serviceregister/leave-details/leave-details-form/leave-details-form.component';
import { LeaveDetailsGridComponent } from './hrms/serviceregister/leave-details/leave-details-grid/leave-details-grid.component';
import { EmpBasicDetailFormComponent } from './hrms/serviceregister/employee-basic-details/emp-basic-detail-form/emp-basic-detail-form.component';
import { ReligionFormComponent } from './master/religion/religion-form/religion-form.component';
import { ScalesFormComponent } from './master/scales/scales-form/scales-form.component';
import { ScalesGridComponent } from './master/scales/scales-grid/scales-grid.component';
import { SalaryGridComponent } from './master/salary/salary-grid/salary-grid.component';
import { SalaryFormComponent } from './master/salary/salary-form/salary-form.component';
import { LeavesGridComponent } from './master/leaves/leaves-grid/leaves-grid.component';
import { QualificationInputFormComponent } from './hrms/serviceregister/qualification-input/qualification-input-form/qualification-input-form.component';
import { TransferComponent } from './hrms/transfer/transfer.component';
//HRMS Imports ends

//Land Procurement Imports starts
import { DemandsurveyGridComponent } from './landprocurement/demand-survey/demandsurvey-grid/demandsurvey-grid.component';
import { DemandsurveyFormComponent } from './landprocurement/demand-survey/demandsurvey-form/demandsurvey-form.component';
import { ApprovalFormComponent } from './landprocurement/approval/approval-form/approval-form.component';
import { ApprovalGridComponent } from './landprocurement/approval/approval-grid/approval-grid.component';
import { RegisterdocGridComponent } from './landprocurement/registereddoc/registerdoc-grid/registerdoc-grid.component';
import { RegisterdocFormComponent } from './landprocurement/registereddoc/registerdoc-form/registerdoc-form.component';
//Land Procurement Imports ends

//Technical Additional Modules Imports Starts
import { ProjectProgressComponent } from './technical/project-progress/project-progress.component';
import { DashboardTechComponent } from './technical/dashboard/dashboard.component';
import { WorkslipStatementComponent } from './technical/billing/workslip-statement/workslip-statement.component';
import { WorkprogressFormComponent } from './technical/project-progress/work-progress/workprogress-form/workprogress-form.component';
import { ScheduleFormComponent } from './technical/project-schedule/schedule-form/schedule-form.component';
import { GlobalDataFormComponent } from './technical/global-data/global-data-form/global-data-form.component';
import { BillPaybillsFormComponent } from './technical/billing/bill-paybills/bill-paybills-form/bill-paybills-form.component';
import { BillSummaryComponent } from './technical/billing/bill-summary/bill-summary.component';
import { BillStatusComponent } from './technical/billing/bill-status/bill-status.component';
import { BillPaymentsFormComponent } from './technical/billing/bill-payments/bill-payments-form/bill-payments-form.component';
import { TenderBillFormComponent } from './technical/billing/tender-bill/tender-bill-form/tender-bill-form.component';
import { RaBillFormComponent } from './technical/billing/ra-bill/ra-bill-form/ra-bill-form.component';
import { BillingComponent } from './technical/billing/billing.component';
import { IssueorderFormComponent } from './technical/work-order/issue-order/issueorder-form/issueorder-form.component';
import { MetricsFormComponent } from './technical/work-order/metrics/metrics-form/metrics-form.component';
import { TaxFormComponent } from './technical/work-order/tax/tax-form/tax-form.component';
import { WorktypeGridComponent } from './master/work-type/worktype-grid/worktype-grid.component';
import { WorktypeFormComponent } from './master/work-type/worktype-form/worktype-form.component';
import { MetricsGridComponent } from './technical/work-order/metrics/metrics-grid/metrics-grid.component';
import { ManualLotteryTokenComponent } from './allocation/manual-lottery/manual-lottery-token/manual-lottery-token.component';
import { CpCrViewComponent } from './legal/case-proceeding/cp-cr-grid/cp-cr-grid.component';
import { AdvocatesFormComponent } from './legal/advocates/advocates-form/advocates-form.component';
import { KhbnotificationltrComponent } from './applicant/khbnotificationltr/khbnotificationltr.component';
import { ApplicantQueryComponent } from './applicant/applicant-query/applicant-query.component';
import { DirectAllocationComponent } from './applicant/direct-allocation/direct-allocation.component';

//Technical Additional Modules Imports Ends


import {AddBundleComponent} from './Godown/addBundle/addBundle.component';
import{GodownComponent} from './Godown/Godown.component';
import{GodownMenu} from './Godown/godownMenu/godownMenu.component';
import{AppRetRequestComponent} from './Godown/appretRequest/appretRequest.component';
import {GodownQueryComponent} from './Godown/query/query.component';
import { NoticeCancellationComponent } from './allocation/notice-cancellation/notice-cancellation.component';
import { NotieLetterComponent } from './pdf-forms/notie-letter/notie-letter.component';
import { OrderLetterComponent } from './pdf-forms/order-letter/order-letter.component';

import { BillsToFinanceComponent } from './legal/bills-to-finance/bills-to-finance.component';
import { GodownReportsComponent } from './Godown/godown-reports/godown-reports.component';
import { BundleReportsComponent } from './Godown/bundle-reports/bundle-reports.component';
import { SubmittedAppReportsComponent } from './Godown/submitted-app-reports/submitted-app-reports.component';
import { RequestAppRecordsComponent } from './Godown/request-app-records/request-app-records.component';

import { AllocationReportsComponent } from './allocation/allocation-reports/allocation-reports.component';
import { AllotedPropertyListComponent } from './allocation/alloted-property-list/alloted-property-list.component';
import { CancellationReportsComponent } from './allocation/cancellation-reports/cancellation-reports.component';
import { PrAllocatedPropListComponent } from './allocation/pr-allocated-prop-list/pr-allocated-prop-list.component';
import { PrVacantPropListComponent } from './allocation/pr-vacant-prop-list/pr-vacant-prop-list.component';
import { ReportsComponent } from './reports/reports.component';
import { VacantCommercialPropertyComponent } from './reports/vacant-commercial-property/vacant-commercial-property.component';
import { AvailBlockedInterDqCornerComponent } from './reports/avail-blocked-inter-dq-corner/avail-blocked-inter-dq-corner.component';
import { IntermediateAvailableSitehouseflatsComponent } from './reports/intermediate-available-sitehouseflats/intermediate-available-sitehouseflats.component';
import { IntermediateBlockedSitehouseflatsComponent } from './reports/intermediate-blocked-sitehouseflats/intermediate-blocked-sitehouseflats.component';
import { DqVacantPropertyComponent } from './reports/dq-vacant-property/dq-vacant-property.component';
import { ClearVacantPropertyComponent } from './reports/clear-vacant-property/clear-vacant-property.component';
import { CornerVacantPropertyComponent } from './reports/corner-vacant-property/corner-vacant-property.component';
import { DistrictwiseVacantPropertyComponent } from './reports/districtwise-vacant-property/districtwise-vacant-property.component';

import{BoardmeetinggridComponent} from './landprocurement/BoardMeet/boardmeetinggrid/boardmeetinggrid.component';
import {BoardmeetingComponent} from './landprocurement/BoardMeet/boardmeeting/boardmeeting.component'
import { BidderViewComponent } from './applicant/bidder-view/bidder-view.component';
import { PhaseGridComponent } from './master/phases/phase-grid/phase-grid.component';
import { PhaseFormComponent } from './master/phases/phase-form/phase-form.component';
import { SchemesGridComponent } from './master/schemes/schemes-grid/schemes-grid.component';
import { SchemesFormComponent } from './master/schemes/schemes-form/schemes-form.component';
import { offlineapplicationComponent } from './applicant/offline-application/offline-application.component';

import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ChangeRequestComponent } from './applicant/change-request/change-request.component';
import { AllotNotallotComponent } from './applicant/allot-notallot/allot-notallot.component';
import { LoginlocComponent } from './ultilities/loginloc/loginloc.component';
import { AllertComponent } from './allert/allert.component';
import{LogGridComponent} from './ultilities/auditTrail-log/loggrid.component';
import { WorkflowAlertComponent } from './ultilities/workflow-alert/workflow-alert/workflow-alert.component';
import { WorkflowAlertGridComponent } from './ultilities/workflow-alert/workflow-alert-grid/workflow-alert-grid.component';
import { LandProjectGridComponent } from './landprocurement/land-project/land-project-grid/land-project-grid.component';
import { LandProjectFormComponent } from './landprocurement/land-project/land-project-form/land-project-form.component';
import { LandProjectDetailsComponent } from './landprocurement/land-details/land-project-details/land-project-details.component';
import { LandTownPlanningGridComponent } from './landprocurement/land-to-town-planning/land-town-planning-grid/land-town-planning-grid.component';
import { LandTownPlanningFormComponent } from './landprocurement/land-to-town-planning/land-town-planning-form/land-town-planning-form.component';
import { ProjectReceivedLpGridComponent } from './planning/project-received-land-pro-details/project-received-lp-grid/project-received-lp-grid.component';
import { ProjectPhaseGridComponent } from './planning/project-phase-details/project-phase-grid/project-phase-grid.component';
import { ProjectPhaseFormComponent } from './planning/project-phase-details/project-phase-form/project-phase-form.component';
import { ReviseBasePriceComponent } from './applicant/revise-base-price/revise-base-price.component';
import { ReviseBaseGridComponent } from './applicant/revise-base-price/revise-base-grid/revise-base-grid.component';
import { ApplicantPaymentComponent } from './applicant/applicant-payment/applicant-payment.component';
import { UpdationApplicantFormComponent } from './applicant/updation-applicant-details/updation-applicant-form/updation-applicant-form.component';
import { ApplicantDetailsUpdateComponent } from './applicant/applicant-details-update/applicant-details-update.component';
import { OfflineApplicationGridComponent } from './applicant/offline-application/offline-application-grid/offline-application-grid.component';
import { SixoneimportlandprocComponent } from './landprocurement/sixoneimportlandproc/sixoneimportlandproc.component';
import { LotteryReportComponent } from './allocation/lottery-report/lottery-report.component';
import { LpAgreementGridComponent } from './landprocurement/land-purchase/land-pur-agreements/lp-agreement-grid/lp-agreement-grid.component';
import { LpProfessionGridComponent } from './landprocurement/land-purchase/land-pur-profession/lp-profession-grid/lp-profession-grid.component';
import { LpPaymentGridComponent } from './landprocurement/land-purchase/land-pur-payment/lp-payment-grid/lp-payment-grid.component';
import { JointVentureComponent } from './landprocurement/joint-venture/joint-venture.component';
import { JvExceptenceGridComponent } from './landprocurement/joint-venture/jv-exceptence/jv-exceptence-grid/jv-exceptence-grid.component';
import { LpPaymentFormComponent } from './landprocurement/land-purchase/land-pur-payment/lp-payment-form/lp-payment-form.component';
import { JvPossessionFormComponent } from './landprocurement/joint-venture/jv-possession/jv-possession-form/jv-possession-form.component';
import { JvPossessionGridComponent } from './landprocurement/joint-venture/jv-possession/jv-possession-grid/jv-possession-grid.component';
import { JvAgreementGridComponent } from './landprocurement/joint-venture/jv-agreements/jv-agreement-grid/jv-agreement-grid.component';
import { LpPurchaseFormComponent } from './landprocurement/land-purchase/land-pur-purchase/lp-purchase-form/lp-purchase-form.component';
import { LpAgreementFormComponent } from './landprocurement/land-purchase/land-pur-agreements/lp-agreement-form/lp-agreement-form.component';
import { JvAgreementFormComponent } from './landprocurement/joint-venture/jv-agreements/jv-agreement-form/jv-agreement-form.component';
import { LpPurchaseGridComponent } from './landprocurement/land-purchase/land-pur-purchase/lp-purchase-grid/lp-purchase-grid.component';
import { LpProfessionFormComponent } from './landprocurement/land-purchase/land-pur-profession/lp-profession-form/lp-profession-form.component';
import { JvExceptenceFormComponent } from './landprocurement/joint-venture/jv-exceptence/jv-exceptence-form/jv-exceptence-form.component';
import { ManualLotteryComponent } from './allocation/manual-lottery/manual-lottery.component';
import { UserApplicationViewComponent } from './user-application/user-application-view/user-application-view.component';
import { LandProcurementDetailsComponent } from './landprocurement/land-procurement-details/land-procurement-details.component';
import { CheckComponent } from './legal/check/check.component';
import { ProjectReceivedLpFormComponent } from './planning/project-received-land-pro-details/project-received-lp-form/project-received-lp-form.component';
import { SaledeedComponent } from './allocation/saledeed/saledeed.component';

import { RecoveryComponent } from './recovery/recovery.component';
import { BuildingGridComponent } from './recovery/buildingdetails/building-grid/building-grid.component';
import { BuildingFormComponent } from './recovery/buildingdetails/building-form/building-form.component';
import { RateFixationGridComponent } from './recovery/rate-fixation/rate-fixation-grid/rate-fixation-grid.component';
import { RateFixationFormComponent } from './recovery/rate-fixation/rate-fixation-form/rate-fixation-form.component';
import { AgreementsFormComponent } from './recovery/Agreements/agreements-form/agreements-form.component';
import { PaymentReceiptsGridComponent } from './recovery/Payment-Receipts/payment-receipts-grid/payment-receipts-grid.component';
import { AgreementsGridComponent } from './recovery/Agreements/agreements-grid/agreements-grid.component';
import { PaymentReceiptsFormComponent } from './recovery/Payment-Receipts/payment-receipts-form/payment-receipts-form.component';
import { RenewalsGridComponent } from './recovery/Renewals/renewals-grid/renewals-grid.component';
import { RenewalsFormComponent } from './recovery/Renewals/renewals-form/renewals-form.component';
import { BlockGridComponent } from './recovery/block/block-grid/block-grid.component';
import { BlockFormComponent } from './recovery/block/block-form/block-form.component';
import { PropertyGridComponent } from './recovery/property/property-grid/property-grid.component';
import { PropertyFormComponent } from './recovery/property/property-form/property-form.component';
import { PaymentChallanFormComponent } from './recovery/payment-challan/payment-challan-form/payment-challan-form.component';
import { PaymentChallanGridComponent } from './recovery/payment-challan/payment-challan-grid/payment-challan-grid.component';
import { CustomerGridComponent } from './recovery/customer/customer-grid/customer-grid.component';
import { RecoveryMenuComponent } from './recovery/recovery-menu/recovery-menu.component';
import { CustomerFormComponent } from './recovery/customer/customer-form/customer-form.component';
import { RequestPropertyGridComponent } from './recovery/request-property/request-property-grid/request-property-grid.component';
import { RequestPropertyFormComponent } from './recovery/request-property/request-property-form/request-property-form.component';
import { RecoveryReportGridComponent } from './recovery/recovery-reports/recovery-report-grid/recovery-report-grid.component';
import { RecoveryReportFormComponent } from './recovery/recovery-reports/recovery-report-form/recovery-report-form.component';
import { RequestPropertiesComponent } from './recovery/request-properties/request-properties.component';
import { AgreementsAppComponent } from './recovery/agreements-app/agreements-app.component';
import { RequestPropertyAppFormComponent } from './recovery/request-properties/request-property-approval/request-property-app-form/request-property-app-form.component';
import { RequestPropertyAppGridComponent } from './recovery/request-properties/request-property-approval/request-property-app-grid/request-property-app-grid.component';
import { PaymentChallAppGridComponent } from './recovery/payment-chall-approval/payment-chall-app-grid/payment-chall-app-grid.component';
import { AgreementAppGridComponent } from './recovery/agreements-app/agreements-approval/agreement-app-grid/agreement-app-grid.component';
import { AgreementAppFormComponent } from './recovery/agreements-app/agreements-approval/agreement-app-form/agreement-app-form.component';
import { PaymentChallAppFormComponent } from './recovery/payment-chall-approval/payment-chall-app-form/payment-chall-app-form.component';
import { PaymentChallApprovalComponent } from './recovery/payment-chall-approval/payment-chall-approval.component';
import { PaymentReceiptAppGirdComponent } from './recovery/payment-receipt-approval/payment-receipt-app-gird/payment-receipt-app-gird.component';
import { PaymentReceiptApprovalComponent } from './recovery/payment-receipt-approval/payment-receipt-approval.component';
import { PaymentReceiptAppFormComponent } from './recovery/payment-receipt-approval/payment-receipt-app-form/payment-receipt-app-form.component';
import { MasterDisplayComponent } from './master/master-display/master-display.component';
import { HospitalGridComponent } from './master/hospitals/hospital-grid/hospital-grid.component';
import { HospitalFormComponent } from './master/hospitals/hospital-form/hospital-form.component';
import { MasterCalendarGridComponent } from './master/master-calendar/master-calendar-grid/master-calendar-grid.component';
import { MasterCalendarFormComponent } from './master/master-calendar/master-calendar-form/master-calendar-form.component';
import { ServiceRegViewFormComponent } from './hrms/serviceregister/service-register-views/service-reg-view-form/service-reg-view-form.component';
import { AddressDetailsComponent } from './hrms/serviceregister/address-details/address-details/address-details.component';
import { AddressDetailsFormComponent } from './hrms/serviceregister/address-details/address-details-form/address-details-form.component';
import { ExperiencedetailsGridComponent } from './hrms/serviceregister/experiencedetails/experiencedetails-grid/experiencedetails-grid.component';
import { ExperiencedetailsFormComponent } from './hrms/serviceregister/experiencedetails/experiencedetails-form/experiencedetails-form.component';
import { PoliceVerificationGridComponent } from './hrms/serviceregister/Police Verification/police-verification-grid/police-verification-grid.component';
import { PoliceVerificationComponent } from './hrms/serviceregister/Police Verification/police-verification/police-verification.component';
import { LeaveBalDetGridComponent } from './hrms/serviceregister/leave-balance-details/leave-bal-det-grid/leave-bal-det-grid.component';
import { LeaveBalDetFormComponent } from './hrms/serviceregister/leave-balance-details/leave-bal-det-form/leave-bal-det-form.component';
import { PayrollMastersComponent } from './hrms/payroll/payroll-masters/payroll-masters.component';
import { AllowanceCodeGridComponent } from './hrms/payroll/payroll-masters/allowance-codes/allowance-code-grid/allowance-code-grid.component';
import { AllowanceCodeComponent } from './hrms/payroll/payroll-masters/allowance-codes/allowance-code/allowance-code.component';
import { DeductionCodeGridComponent } from './hrms/payroll/payroll-masters/deduction-codes/deduction-code-grid/deduction-code-grid.component';
import { DeductionCodeComponent } from './hrms/payroll/payroll-masters/deduction-codes/deduction-code/deduction-code.component';
import { FormulaGridComponent } from './hrms/payroll/payroll-masters/formula-details/formula-grid/formula-grid.component';
import { FormulaFormComponent } from './hrms/payroll/payroll-masters/formula-details/formula-form/formula-form.component';
import { OrganisationProfileComponent } from './hrms/payroll/organisation-profile/organisation-profile.component';
import { IncomeTaxGridComponent } from './hrms/payroll/organisation-profile/income-tax/income-tax-grid/income-tax-grid.component';
import { ProfessionalTaxGridComponent } from './hrms/payroll/organisation-profile/professional-tax/professional-tax-grid/professional-tax-grid.component';
import { ProfessionalTaxFormComponent } from './hrms/payroll/organisation-profile/professional-tax/professional-tax-form/professional-tax-form.component';
import { IncomeTaxFormComponent } from './hrms/payroll/organisation-profile/income-tax/income-tax-form/income-tax-form.component';
import { ControlDataComponent } from './hrms/payroll/organisation-profile/control-data/control-data.component';
import { PayMonthlyGridComponent } from './hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-grid/pay-monthly-grid.component';
import { PayMonthlyFormComponent } from './hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-form/pay-monthly-form.component';
import { EmpSalaryDetailsComponent } from './hrms/payroll/emp-salary-details/emp-salary-details.component';
import { EmpBasicDetailsGridComponent } from './hrms/payroll/emp-salary-details/emp-basic-details/emp-basic-details-grid/emp-basic-details-grid.component';
import { FixedAllowanceGridComponent } from './hrms/payroll/emp-salary-details/fixed-allowance/fixed-allowance-grid/fixed-allowance-grid.component';
import { FixedAllowanceFormComponent } from './hrms/payroll/emp-salary-details/fixed-allowance/fixed-allowance-form/fixed-allowance-form.component';
import { VariableAllowanceGridComponent } from './hrms/payroll/emp-salary-details/variable-allowance/variable-allowance-grid/variable-allowance-grid.component';
import { VariableAllowanceFormComponent } from './hrms/payroll/emp-salary-details/variable-allowance/variable-allowance-form/variable-allowance-form.component';
import { FixedDeductionGridComponent } from './hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-grid/fixed-deduction-grid.component';
import { VariableDeductionGridComponent } from './hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-grid/variable-deduction-grid.component';
import { VariableDeductionFormComponent } from './hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-form/variable-deduction-form.component';
import { LoanDetFormComponent } from './hrms/payroll/emp-salary-details/loan-details/loan-det-form/loan-det-form.component';
import { EmpBasicDetailsFormComponent } from './hrms/payroll/emp-salary-details/emp-basic-details/emp-basic-details-form/emp-basic-details-form.component';
import { PayrollProcessDetailsMenuComponent } from './hrms/payroll/payroll-process-details/payroll-process-details-menu/payroll-process-details-menu.component';
import { PayrollPaymonthComponent } from './hrms/payroll/payroll-process-details/payroll-paymonth/payroll-paymonth.component';
import { MedicalReimburesmentGridComponent } from './hrms/employee-claims/Medical-Reimbursment/medical-reimburesment-grid/medical-reimburesment-grid.component';
import { MedicalReimburesmentComponent } from './hrms/employee-claims/Medical-Reimbursment/medical-reimburesment/medical-reimburesment.component';
import { MedReimSanctionGridComponent } from './hrms/employee-claims/med-reim-sanction/med-reim-sanction-grid/med-reim-sanction-grid.component';
import { MedReimSanctionFormComponent } from './hrms/employee-claims/med-reim-sanction/med-reim-sanction-form/med-reim-sanction-form.component';
import { LeaveencashmentGridComponent } from './hrms/employee-claims/Leave Encashment/leaveencashment-grid/leaveencashment-grid.component';
import { LeaveencashmentComponent } from './hrms/employee-claims/Leave Encashment/leaveencashment/leaveencashment.component';
import { MedicalReimbursmentRecordsGridComponent } from './hrms/employee-claims/medical-reimbursment-records/medical-reimbursment-records-grid/medical-reimbursment-records-grid.component';
import { MedicalReimbursmentRecordsFormComponent } from './hrms/employee-claims/medical-reimbursment-records/medical-reimbursment-records-form/medical-reimbursment-records-form.component';
import { MedReimAuthorizationComponent } from './hrms/employee-claims/med-reim-authorization/med-reim-authorization/med-reim-authorization.component';
import { HtcLtcAuthComponent } from './hrms/employee-claims/htc-ltc-authorization/htc-ltc-auth/htc-ltc-auth.component';
import { LeaveEncashAuthComponent } from './hrms/employee-claims/leave-encash-authorization/leave-encash-auth/leave-encash-auth.component';
import { LeaveEncashSanctionGridComponent } from './hrms/employee-claims/leave-encash-sanction/leave-encash-sanction-grid/leave-encash-sanction-grid.component';
import { LeaveEncashSanctionFormComponent } from './hrms/employee-claims/leave-encash-sanction/leave-encash-sanction-form/leave-encash-sanction-form.component';
import { LeaveEncashmentRecGridComponent } from './hrms/employee-claims/leave-encashment-rec/leave-encashment-rec-grid/leave-encashment-rec-grid.component';
import { LeaveEncashmentRecFormComponent } from './hrms/employee-claims/leave-encashment-rec/leave-encashment-rec-form/leave-encashment-rec-form.component';
import { DepartmentalExamComponent } from './hrms/Departmental-Exam/departmental-exam.component';
import { NominationComponent } from './hrms/Nomination/nomination.component';
import { NominationApplicationGridComponent } from './hrms/Nomination/Nomination-App/nomination-application-grid/nomination-application-grid.component';
import { NominationApplicationComponent } from './hrms/Nomination/Nomination-App/nomination-application/nomination-application.component';
import { NominationApprovalGridComponent } from './hrms/Nomination/nomination-approval/nomination-approval-grid/nomination-approval-grid.component';
import { NominationApprovalFormComponent } from './hrms/Nomination/nomination-approval/nomination-approval-form/nomination-approval-form.component';
import { NominationSanGridComponent } from './hrms/Nomination/nomination-san/nomination-san-grid/nomination-san-grid.component';
import { NominationRecGridComponent } from './hrms/Nomination/nomination-rec/nomination-rec-grid/nomination-rec-grid.component';
import { DepartEnquiryMenuComponent } from './hrms/depart-enquiry/depart-enquiry-menu/depart-enquiry-menu.component';
import { ComplaintsRegGridComponent } from './hrms/depart-enquiry/complaints-registration/complaints-reg-grid/complaints-reg-grid.component';
import { ComplaintsRegFormComponent } from './hrms/depart-enquiry/complaints-registration/complaints-reg-form/complaints-reg-form.component';
import { ShowCaseGridComponent } from './hrms/depart-enquiry/show-case-noties/show-case-grid/show-case-grid.component';
import { ShowCaseFormComponent } from './hrms/depart-enquiry/show-case-noties/show-case-form/show-case-form.component';
import { ShowCauseAckGridComponent } from './hrms/depart-enquiry/showcause-notice-acknowledgement-dgos-reply/show-cause-ack-grid/show-cause-ack-grid.component';
import { ShowCauseAckFormComponent } from './hrms/depart-enquiry/showcause-notice-acknowledgement-dgos-reply/show-cause-ack-form/show-cause-ack-form.component';
import { EnquiryProceedingGridComponent } from './hrms/depart-enquiry/enquiry-proceedings/enquiry-proceeding-grid/enquiry-proceeding-grid.component';
import { EnquiryProceedingFormComponent } from './hrms/depart-enquiry/enquiry-proceedings/enquiry-proceeding-form/enquiry-proceeding-form.component';
import { InitiateDepartEnquiryGridComponent } from './hrms/depart-enquiry/initiate-depart-enquiry/initiate-depart-enquiry-grid/initiate-depart-enquiry-grid.component';
import { InitiateDepartEnquiryFormComponent } from './hrms/depart-enquiry/initiate-depart-enquiry/initiate-depart-enquiry-form/initiate-depart-enquiry-form.component';
import { ComplaintRegAuthComponent } from './hrms/depart-enquiry/complaint-reg-authorization/complaint-reg-auth/complaint-reg-auth.component';
import { ComplaintRegAuthFormComponent } from './hrms/depart-enquiry/complaint-reg-authorization/complaint-reg-auth-form/complaint-reg-auth-form.component';
import { ScnAuthorizationComponent } from './hrms/depart-enquiry/scn-authorization/scn-authorization/scn-authorization.component';
import { ScnAuthorizationFormComponent } from './hrms/depart-enquiry/scn-authorization/scn-authorization-form/scn-authorization-form.component';
import { ScnRemainderComponent } from './hrms/depart-enquiry/scn-authorization/scn-remainder/scn-remainder.component';
import { ScnRemainderFormComponent } from './hrms/depart-enquiry/scn-authorization/scn-remainder-form/scn-remainder-form.component';
import { EnquiryCloserGridComponent } from './hrms/depart-enquiry/enquiry-closure/enquiry-closer-grid/enquiry-closer-grid.component';
import { EnquiryCloserFormComponent } from './hrms/depart-enquiry/enquiry-closure/enquiry-closer-form/enquiry-closer-form.component';
import { ExternalEnquiryFormComponent } from './hrms/depart-enquiry/external-enquiry/external-enquiry-form/external-enquiry-form.component';
import { ExternalEnquiryGridComponent } from './hrms/depart-enquiry/external-enquiry/external-enquiry-grid/external-enquiry-grid.component';
import { ExternalEnquiryClosureGridComponent } from './hrms/depart-enquiry/external-enquiry-closure/external-enquiry-closure-grid/external-enquiry-closure-grid.component';
import { ExternalEnquiryClosureFormComponent } from './hrms/depart-enquiry/external-enquiry-closure/external-enquiry-closure-form/external-enquiry-closure-form.component';
import { AttendanceLeavesComponent } from './hrms/Attendance-Leaves/attendance-leaves.component';
import { DailyAttendanceGridComponent } from './hrms/Attendance-Leaves/daily-attendance/daily-attendance-grid/daily-attendance-grid.component';
import { DailyAttendanceFormComponent } from './hrms/Attendance-Leaves/daily-attendance/daily-attendance-form/daily-attendance-form.component';
import { DailyAttendanceOutGridComponent } from './hrms/Attendance-Leaves/daily-attendance-out/daily-attendance-out-grid/daily-attendance-out-grid.component';
import { DailyAttendanceOutFormComponent } from './hrms/Attendance-Leaves/daily-attendance-out/daily-attendance-out-form/daily-attendance-out-form.component';
import { LeaveTypeGridComponent } from './hrms/Attendance-Leaves/Leaves/leave-type-grid/leave-type-grid.component';
import { LeaveTypeComponent } from './hrms/Attendance-Leaves/Leaves/leave-type/leave-type.component';
import { LeaveAuthGridComponent } from './hrms/Attendance-Leaves/leave-authorization/leave-auth-grid/leave-auth-grid.component';
import { LeaveAuthFormComponent } from './hrms/Attendance-Leaves/leave-authorization/leave-auth-form/leave-auth-form.component';
import { LeaveSanctionGridComponent } from './hrms/Attendance-Leaves/leave-sanction/leave-sanction-grid/leave-sanction-grid.component';
import { MonthlyLeaveAttenGridComponent } from './hrms/Attendance-Leaves/monthly-leave-atten/monthly-leave-atten-grid/monthly-leave-atten-grid.component';
import { LeaveSanctionFormComponent } from './hrms/Attendance-Leaves/leave-sanction/leave-sanction-form/leave-sanction-form.component';
import { TimeRollGenGridComponent } from './hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-grid/time-roll-gen-grid.component';
import { TimeRollGenFormComponent } from './hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-form/time-roll-gen-form.component';
import { TimeRollApprveGridComponent } from './hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-grid/time-roll-apprve-grid.component';
import { TimeRollApprveFormComponent } from './hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-form/time-roll-apprve-form.component';
import { TimeRollSanGridComponent } from './hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-grid/time-roll-san-grid.component';
import { TimeRollSanFormComponent } from './hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-form/time-roll-san-form.component';
import { TimeRollFinGridComponent } from './hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-grid/time-roll-fin-grid.component';
import { TimeRollFinFormComponent } from './hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-form/time-roll-fin-form.component';
import { TimeRollUnintiGridComponent } from './hrms/Attendance-Leaves/time-roll-unintigrated/time-roll-uninti-grid/time-roll-uninti-grid.component';
import { TimeRollUnintiFormComponent } from './hrms/Attendance-Leaves/time-roll-unintigrated/time-roll-uninti-form/time-roll-uninti-form.component';
import { LeaveCreditComponent } from './hrms/Leave-Credit/leave-credit.component';
import { LeavecreditGridComponent } from './hrms/Leave-Credit/leave-credits/leavecredit-grid/leavecredit-grid.component';
import { LeaveCreditAuthComponent } from './hrms/Leave-Credit/leave-credit-authorization/leave-credit-auth/leave-credit-auth.component';
import { LeaveCreditAuthFormComponent } from './hrms/Leave-Credit/leave-credit-authorization/leave-credit-auth-form/leave-credit-auth-form.component';
import { LeaveCreditSanctionGridComponent } from './hrms/Leave-Credit/leave-credit-sanction/leave-credit-sanction-grid/leave-credit-sanction-grid.component';
import { LeaveCreditSanctionFormComponent } from './hrms/Leave-Credit/leave-credit-sanction/leave-credit-sanction-form/leave-credit-sanction-form.component';
import { LeaveCreditBulkComponent } from './hrms/Leave-Credit/leave-credit-bulk/leave-credit-bulk/leave-credit-bulk.component';
import { LeaveCreditBulkFormComponent } from './hrms/Leave-Credit/leave-credit-bulk/leave-credit-bulk-form/leave-credit-bulk-form.component';
import { BulkLeaveCreditApprovalComponent } from './hrms/Leave-Credit/bulk-leave-credit-approval/bulk-leave-credit-approval.component';
import { BulkLeaveCreditSanctionComponent } from './hrms/Leave-Credit/bulk-leave-credit-sanction/bulk-leave-credit-sanction.component';
import { MonthlyAttendanceComponent } from './hrms/serviceregister/Monthly Attendance/monthly-attendance/monthly-attendance.component';
import { MonthlyAttendanceGridComponent } from './hrms/serviceregister/Monthly Attendance/monthly-attendance-grid/monthly-attendance-grid.component';
import { PromotionsComponent } from './hrms/Promotions/promotions.component';
import { PromotionGridComponent } from './hrms/Promotions/Promotions/promotion-grid/promotion-grid.component';
import { PromotionComponent } from './hrms/Promotions/Promotions/promotion/promotion.component';
import { PromotionAuthGridComponent } from './hrms/Promotions/promotion-authorization/promotion-auth-grid/promotion-auth-grid.component';
import { PromotionAuthFormComponent } from './hrms/Promotions/promotion-authorization/promotion-auth-form/promotion-auth-form.component';
import { PromotionsSanctionGridComponent } from './hrms/Promotions/promotions-sanction/promotions-sanction-grid/promotions-sanction-grid.component';
import { PromotionsSanctionFormComponent } from './hrms/Promotions/promotions-sanction/promotions-sanction-form/promotions-sanction-form.component';
import { IncrementsComponent } from './hrms/Increments/increments.component';
import { GenIncrListGridComponent } from './hrms/Increments/generate-increment-list/gen-incr-list-grid/gen-incr-list-grid.component';
import { GenIncrListComponent } from './hrms/Increments/generate-increment-list/gen-incr-list/gen-incr-list.component';
import { IncrListAuthGridComponent } from './hrms/Increments/increment-list-authorization/incr-list-auth-grid/incr-list-auth-grid.component';
import { IncrListAuthComponent } from './hrms/Increments/increment-list-authorization/incr-list-auth/incr-list-auth.component';
import { IncrementsSanctionGridComponent } from './hrms/Increments/increments-sanction/increments-sanction-grid/increments-sanction-grid.component';
import { IncrementsSanctionFormComponent } from './hrms/Increments/increments-sanction/increments-sanction-form/increments-sanction-form.component';
import { IncrementPostingGridComponent } from './hrms/Increments/increment-posting/increment-posting-grid/increment-posting-grid.component';
import { IncrementPostingFormComponent } from './hrms/Increments/increment-posting/increment-posting-form/increment-posting-form.component';
import { RtiComponent } from './hrms/RTI/rti/rti.component';
import { RtiGridComponent } from './hrms/RTI/rti-grid/rti-grid.component';
import { EmployeeSeparationComponent } from './hrms/Employee-Separation/employee-separation.component';
import { EmpRetirementListComponent } from './hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list/emp-retirement-list.component';
import { EmpSeparationGridComponent } from './hrms/Employee-Separation/emp-separation/emp-separation-grid/emp-separation-grid.component';
import { EmpSeparationComponent } from './hrms/Employee-Separation/emp-separation/emp-separation/emp-separation.component';
import { EmpSepAuthComponent } from './hrms/Employee-Separation/emp-sep-authorization/emp-sep-auth/emp-sep-auth.component';
import { EmpSepAuthFormComponent } from './hrms/Employee-Separation/emp-sep-authorization/emp-sep-auth-form/emp-sep-auth-form.component';
import { PayrollAttendaceLeaveComponent } from './hrms/payroll/payroll-process-details/payroll-attendace-leave/payroll-attendace-leave.component';
import { PayrollProcessPayrollComponent } from './hrms/payroll/payroll-process-details/payroll-process-payroll/payroll-process-payroll.component';
import { PayrollFinalizePayrollComponent } from './hrms/payroll/payroll-process-details/payroll-finalize-payroll/payroll-finalize-payroll.component';
import { PayrollReportsMenuComponent } from './hrms/payroll/payroll-reports/payroll-reports-menu/payroll-reports-menu.component';
import { MasterReportsComponent } from './hrms/payroll/payroll-reports/master-reports/master-reports.component';
import { SummaryReportsComponent } from './hrms/payroll/payroll-reports/summary-reports/summary-reports.component';
import { MiscellaneousReportsComponent } from './hrms/payroll/payroll-reports/miscellaneous-reports/miscellaneous-reports.component';
import { VariableAllowdeductionComponent } from './hrms/payroll/variable-allowance-deduction-details/variable-allowdeduction/variable-allowdeduction.component';
import { IncometaxParameterComponent } from './hrms/payroll/incometax-parameter/incometax-parameter.component';
import { PayrollProcessComponent } from './hrms/payroll/payroll-process/payroll-process.component';
import { PayrollFinalizeComponent } from './hrms/payroll/payroll-finalize/payroll-finalize.component';
import { PayrollAuthorizeGridComponent } from './hrms/payroll/payroll-authorize/payroll-authorize-grid/payroll-authorize-grid.component';
import { PayrollAuthorizeFormComponent } from './hrms/payroll/payroll-authorize/payroll-authorize-form/payroll-authorize-form.component';
import { PayrollSanctionGridComponent } from './hrms/payroll/payroll-sanction/payroll-sanction-grid/payroll-sanction-grid.component';
import { PayrollSanctionFormComponent } from './hrms/payroll/payroll-sanction/payroll-sanction-form/payroll-sanction-form.component';
import { MonthlyAttDetComponent } from './hrms/payroll/monthly-attendance-details/monthly-att-det/monthly-att-det.component';
import { TransferAuthorizationGridComponent } from './hrms/transfer/transfer-authorization/transfer-authorization-grid/transfer-authorization-grid.component';
import { TransferAuthorizationFormComponent } from './hrms/transfer/transfer-authorization/transfer-authorization-form/transfer-authorization-form.component';
import { TransferSanctionGridComponent } from './hrms/transfer/transfer-sanction/transfer-sanction-grid/transfer-sanction-grid.component';
import { TransferSanctionFormComponent } from './hrms/transfer/transfer-sanction/transfer-sanction-form/transfer-sanction-form.component';
import { TransferRecordersGridComponent } from './hrms/transfer/transfer-recorders/transfer-recorders-grid/transfer-recorders-grid.component';
import { TransferRecordersFormComponent } from './hrms/transfer/transfer-recorders/transfer-recorders-form/transfer-recorders-form.component';
import { DeputaionComponent } from './hrms/deputaion/deputaion.component';
import { DeputationAuthorizationComponent } from './hrms/deputaion/deputation-authorization/deputation-authorization/deputation-authorization.component';
import { DeputationAuthorizationFormComponent } from './hrms/deputaion/deputation-authorization/deputation-authorization-form/deputation-authorization-form.component';
import { DeputaionSanctionGridComponent } from './hrms/deputaion/deputaion-sanction/deputaion-sanction-grid/deputaion-sanction-grid.component';
import { DeputaionSanctionFormComponent } from './hrms/deputaion/deputaion-sanction/deputaion-sanction-form/deputaion-sanction-form.component';
import { DeputationRecGridComponent } from './hrms/deputaion/deputaion-rec/deputation-rec-grid/deputation-rec-grid.component';
import { DeputationRecFormComponent } from './hrms/deputaion/deputaion-rec/deputation-rec-form/deputation-rec-form.component';
import { EmployeeClaimsComponent } from './hrms/employee-claims/employee-claims.component';
import { HtcLtcSanctionGridComponent } from './hrms/employee-claims/htc-ltc-sanction/htc-ltc-sanction-grid/htc-ltc-sanction-grid.component';
import { HtcLtcSanctionFormComponent } from './hrms/employee-claims/htc-ltc-sanction/htc-ltc-sanction-form/htc-ltc-sanction-form.component';
import { HtcLtcRecGridComponent } from './hrms/employee-claims/htc-ltc-rec/htc-ltc-rec--grid/htc-ltc-rec--grid.component';
import { HtcLtcRecFormComponent } from './hrms/employee-claims/htc-ltc-rec/htc-ltc-rec--form/htc-ltc-rec--form.component';
import { TrainingComponent } from './hrms/Training/training.component';
import { TrainingApprovalGridComponent } from './hrms/Training/training-approval/training-approval-grid/training-approval-grid.component';
import { TrainingApprovalFormComponent } from './hrms/Training/training-approval/training-approval-form/training-approval-form.component';
import { TrainingSanctionGridComponent } from './hrms/Training/training-sanction/training-sanction-grid/training-sanction-grid.component';
import { TrainingSanctionFormComponent } from './hrms/Training/training-sanction/training-sanction-form/training-sanction-form.component';
import { TrainingRecordGridComponent } from './hrms/Training/training-record/training-record-grid/training-record-grid.component';
import { DeptExamAuthComponent } from './hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth/dept-exam-auth.component';
import { DeptExamAuthFormComponent } from './hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth-form/dept-exam-auth-form.component';
import { DeptExamSanctionGridComponent } from './hrms/Departmental-Exam/dept-exam-sanction/dept-exam-sanction-grid/dept-exam-sanction-grid.component';
import { DeptExamSanctionFormComponent } from './hrms/Departmental-Exam/dept-exam-sanction/dept-exam-sanction-form/dept-exam-sanction-form.component';
import { DeptExamRecordGridComponent } from './hrms/Departmental-Exam/dept-exam-record/dept-exam-record-grid/dept-exam-record-grid.component';
import { DeptExamRecordFromComponent } from './hrms/Departmental-Exam/dept-exam-record/dept-exam-record-from/dept-exam-record-from.component';
import { LeavecreditComponent } from './hrms/Leave-Credit/leave-credits/leavecredit/leavecredit.component';
import { RequestGridComponent } from './recovery/request/request-grid/request-grid.component';
import { RequestFormComponent } from './recovery/request/request-form/request-form.component';
import { RenewalApprovalGridComponent } from './recovery/renewal-approval/renewal-approval-grid/renewal-approval-grid.component';
import { RenewalApprovalFormComponent } from './recovery/renewal-approval/renewal-approval-form/renewal-approval-form.component';
import { RenewalApprovalComponent } from './recovery/renewal-approval/renewal-approval.component';
import { PaymentArrearsGridComponent } from './recovery/payment-arrears/payment-arrears-grid/payment-arrears-grid.component';
import { PaymentArrearsFormComponent } from './recovery/payment-arrears/payment-arrears-form/payment-arrears-form.component';
import { TrainingRecordFromComponent } from './hrms/Training/training-record/training-record-from/training-record-from.component';
import { IncrementdetailsFormComponent } from './hrms/serviceregister/incrementdetails/incrementdetails-form/incrementdetails-form.component';
import { DeptenquirydetailsGridComponent } from './hrms/serviceregister/deptenquirydetails/deptenquirydetails-grid/deptenquirydetails-grid.component';
import { DeptenquirydetailsFormComponent } from './hrms/serviceregister/deptenquirydetails/deptenquirydetails-form/deptenquirydetails-form.component';
import { PromotionPostGridComponent } from './hrms/Promotions/promotions-post/promotion-post-grid/promotion-post-grid.component';
import { PromotionPostFormComponent } from './hrms/Promotions/promotions-post/promotion-post-form/promotion-post-form.component';
import { ProListAuthGridComponent } from './hrms/Promotions/promotion-list-authorization/pro-list-auth-grid/pro-list-auth-grid.component';
import { ProListAuthComponent } from './hrms/Promotions/promotion-list-authorization/pro-list-auth/pro-list-auth.component';
import { GenProListGridComponent } from './hrms/Promotions/general-promotion-list/gen-pro-list-grid/gen-pro-list-grid.component';
import { GenProListComponent } from './hrms/Promotions/general-promotion-list/gen-pro-list/gen-pro-list.component';
import { LwfGridComponent } from './hrms/payroll/organisation-profile/lwf/lwf-grid/lwf-grid.component';
import { LwfFormComponent } from './hrms/payroll/organisation-profile/lwf/lwf-form/lwf-form.component';
import { EsiGridComponent } from './hrms/payroll/organisation-profile/esi/esi-grid/esi-grid.component';
import { EsiFormComponent } from './hrms/payroll/organisation-profile/esi/esi-form/esi-form.component';
import { EpfGridComponent } from './hrms/payroll/organisation-profile/epf/epf-grid/epf-grid.component';
import { EpfFormComponent } from './hrms/payroll/organisation-profile/epf/epf-form/epf-form.component';
import { FixedDeductionFormComponent } from './hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-form/fixed-deduction-form.component';
import { NominationSanctionGridComponent } from './hrms/Nomination/nomination-sanction/nomination-sanction-grid/nomination-sanction-grid.component';
import { NominationSanctionFormComponent } from './hrms/Nomination/nomination-sanction/nomination-sanction-form/nomination-sanction-form.component';
import { NominationSanFormComponent } from './hrms/Nomination/nomination-san/nomination-san-form/nomination-san-form.component';
import { NominationRecFormComponent } from './hrms/Nomination/nomination-rec/nomination-rec-form/nomination-rec-form.component';
import { IncrementComponent } from './hrms/Increments/Increments/increment/increment.component';
import { EmployeeSrViewComponent } from './hrms/employee-sr-view/employee-sr-view.component';
import { ComplaintRegSanctionFormComponent } from './hrms/depart-enquiry/complaint-reg-sanction/complaint-reg-sanction-form/complaint-reg-sanction-form.component';
import { ComplaintRegSanctionGridComponent } from './hrms/depart-enquiry/complaint-reg-sanction/complaint-reg-sanction-grid/complaint-reg-sanction-grid.component';
import { ScnSanctionFormComponent } from './hrms/depart-enquiry/scn-sanction/scn-sanction-form/scn-sanction-form.component';
import { ScnSanctionGridComponent } from './hrms/depart-enquiry/scn-sanction/scn-sanction-grid/scn-sanction-grid.component';
import { HtcLtcAuthFormComponent } from './hrms/employee-claims/htc-ltc-authorization/htc-ltc-auth-form/htc-ltc-auth-form.component';
import { LeaveComponent } from './hrms/employee-claims/leave/leave.component';
import { LeaveEncashAuthFormComponent } from './hrms/employee-claims/leave-encash-authorization/leave-encash-auth-form/leave-encash-auth-form.component';
import { MedReimAuthorizationFormComponent } from './hrms/employee-claims/med-reim-authorization/med-reim-authorization-form/med-reim-authorization-form.component';
import { EmpRetirementListFormComponent } from './hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list-form/emp-retirement-list-form.component';
import { IncrementGridComponent } from './hrms/Increments/Increments/increment-grid/increment-grid.component';
import { IncrementdetailsGridComponent } from './hrms/serviceregister/incrementdetails/incrementdetails-grid/incrementdetails-grid.component';
import { JoiningdetailsFormComponent } from './hrms/serviceregister/joiningdetails/joiningdetails-form/joiningdetails-form.component';
import { JoiningdetailsGridComponent } from './hrms/serviceregister/joiningdetails/joiningdetails-grid/joiningdetails-grid.component';
import { MedicalExaminationComponent } from './hrms/serviceregister/Medical Examination/medical-examination/medical-examination.component';
import { MedicalExaminationGridComponent } from './hrms/serviceregister/Medical Examination/medical-examination-grid/medical-examination-grid.component';
import { PromotiondetailsFormComponent } from './hrms/serviceregister/promotiondetails/promotiondetails-form/promotiondetails-form.component';
import { PromotiondetailsGridComponent } from './hrms/serviceregister/promotiondetails/promotiondetails-grid/promotiondetails-grid.component';
import { TrainingDetailsGridComponent } from './hrms/Training/training-details/training-details-grid/training-details-grid.component';
import { TrainingDetailsFormComponent } from './hrms/Training/training-details/training-details-form/training-details-form.component';
import { DepartmentalExamDetailsGridComponent } from './hrms/Departmental-Exam/departmental-exam-details/departmental-exam-details-grid/departmental-exam-details-grid.component';
import { DepartmentalExamDetailsFormComponent } from './hrms/Departmental-Exam/departmental-exam-details/departmental-exam-details-form/departmental-exam-details-form.component';
import { HtcLtcGridComponent } from './hrms/employee-claims/htc-ltc/htc-ltc-grid/htc-ltc-grid.component';
import { HtcLtcFormComponent } from './hrms/employee-claims/htc-ltc/htc-ltc-form/htc-ltc-form.component';
import { DeputationInGridComponent } from './hrms/deputaion/deputation-in/deputation-in-grid/deputation-in-grid.component';
import { DeputationInFormComponent } from './hrms/deputaion/deputation-in/deputation-in-form/deputation-in-form.component';
import { DeputationOutFormComponent } from './hrms/deputaion/deputation-out/deputation-out-form/deputation-out-form.component';
import { DeputationOutGridComponent } from './hrms/deputaion/deputation-out/deputation-out-grid/deputation-out-grid.component';
import { AuctionedPropertiesCancelComponent } from './allocation/auctioned-properties-cancel/auctioned-properties-cancel.component';
import { ViewAuctionedPpropertiesComponent } from './allocation/view-auctioned-properties/view-auctioned-properties.component';

import { PaymentFormComponent } from './allocation/payment-form/payment-form.component';
import { CheckoutFormComponent } from './allocation/checkout-form/checkout-form.component';

//lakshman


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    DashboardComponent,
    UserComponent,
    SettingComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    OfficeGridComponent,
    OfficeFormComponent,
    OfficeComponent,
    ClaimsComponent,
    MasterComponent,
    AllocationComponent,
    MasterMenuComponent,
    ApplicationformComponent,
    ApplicationMenuComponent,
    RegistrationComponent,
    HomepageComponent,
    ChangePasswordComponent,
    GridComponent,
    FormComponent,
    PrAllotmentGridComponent,
    PrAllotmentFormComponent,
    PrAllotmentNotsentComponent,
    PropertyregisterGridComponent,
    PropertyregisterFormComponent,
    SmsGridComponent,
    SmsFormComponent,
    CampaignDetailsComponent,
    WebsitenewsGridComponent,
    WebsitenewsFormComponent,
    ApplicantComponent,
    ProfileComponent,
    ActivelistComponent,
    ApplicationstatusComponent,
    ApplicationViewComponent,
    ApplicantMenuComponent,
    PaymentComponent,
    ScrutinyComponent,
    LotteryComponent,
    AllottmentListComponent,
    NotAllotedListComponent,
    InstallmentconfigComponent,
    AllotmentCancellationComponent,
    ForgotPasswordComponent,
    PaymentConfigComponent,
    FinanceComponent,
    RefundComponent,
    FinanceMenuComponent,
    ChangeAddressComponent,
    RefundRequestComponent,
    NotAllotedRefundComponent,
    RefundlistComponent,
    ProjectMasterComponent,
    ReAllotmentComponent,
    PrintAllotmentletterComponent,
    ChangePropertyComponent,
    WaitingListComponent,
    DefaultersComponent,

    EKhataComponent,
    ProjectmasterFormComponent,
    ProjectmasterGridComponent,
    ChangePropertygridComponent,
    ChangePropertyformComponent,
    InstallmentDueComponent,
    ProvisionAllotmentComponent,
    MaintainanceFeeComponent,
    PlanningComponent,
    PlanningMenuComponent,
  
    ProjectFormComponent,
    ProjectListComponent,
    LandRecordComponent,
    LandrecordformComponent,
    LandrecordlistComponent,
    ValidatelandrecordlistComponent,
    
    PropertyPlanAlllistComponent,
    ConsultantComponent,
    StatutoryClearancesComponent,
    KhbDrawingComponent,
    ApprovedDrawingComponent,
    BuiltDrawingComponent,
    RevisedDrawingComponent,
    ConsultantFromComponent,
    ApprovedDrawingFormComponent,
    BuiltDrawingFormComponent,
    KhbDrawingFormComponent,
    RevisedDrawingFormComponent,
    StatutoryClearancesFormComponent,
    StatutoryClearancesGridComponent,
    RevisedDrawingGridComponent,
    KhbDrawingGridComponent,
    BuiltDrawingGridComponent,
    ApprovedDrawingGridComponent,
    ProjectNamesComponent,
    AllotmentProjectListComponent,
    AllotmentAllottedPropertyComponent,
    PaymentDetailsComponent,
    SaledeedDetailsComponent,
    CancelAllotmentComponent,
    SaleComponent,
    SoldpropertyComponent,
    PropertiesregisterComponent,
    PropertiesregisterFormComponent,
    PropertiesregisterListComponent,
    ConsultantListComponent,
    ScrutinyViewComponent,
    ProvisionlistComponent, 
    FinalListComponent,
    ProjectListsComponent,
    RevisedpropertyregisterComponent,
    RevisedpropertyregisterFormComponent,
    RevisedpropertyregisterGridComponent,
    ApplicationlistComponent,
    PdfFormsComponent,
    KhbnotificationComponent,
    UpdationApplicantFormComponent,
    LandprocurementComponent,
    LandprocurementMenuComponent,
    ViabilityGridComponent,
    ViabilityFormComponent,
    ProposalFormComponent,
    ProposalGridComponent,
    InspectionGridComponent,
    InspectionFormComponent,
    LanddetailsGridComponent,
    LanddetailsFormComponent,
    LandpaymentGridComponent,
    LandpaymentFormComponent,
    RateGridComponent,
    RateFormComponent,
    OnGridComponent,
    OnFormComponent,
    DemandSurveyDraftComponent,
    IdNotificationDraftComponent,
    DistrictViewComponent,
    DistrictFormComponent,
    DeptViewComponent,
    DeptFormComponent,
   CourtFormComponent,
   CourtViewComponent,
   CourttypeViewComponent,
   CourttypeFormComponent,
   AdvocatesFormComponent,
   //AdvocatesViewComponent,
   CrViewComponent,
   CrFormComponent,
   CpFormComponent,
   CpViewComponent,
   LegalComponent,
   LegalMenuComponent,
   LandRecDetailsComponent,
   LandrecGridComponent,
   LandrecFormComponent,
   FooterComponent,
   ELotteryComponent,
   ManualGridComponent,
   ManualFormComponent,
   PaymentConfigViewComponent,
   ApplicantApplicationComponent,
   ApplicantApplicationFormComponent,
   UserApplicationComponent,
   khbChallanComponent,
   StatusviewComponent,
   AppstatusComponent,
   ApplicationinstallmentpayComponent,
   ApplicationcancellationComponent,
   ApplicationrefundComponent,
   TransactionDetailsComponent,
  FooterComponent,
  ELotteryComponent,
  ManualGridComponent,
  ManualFormComponent,
  PaymentConfigViewComponent,
  TechnicalComponent,
  TechnicalMenuComponent,
  TenderGridComponent,
  TenderFormComponent,
  StaffFormComponent,
  StaffGridComponent,
  EquipmentGridComponent,
  EquipmentFormComponent,
  BoqGridComponent,
  BoqFormComponent,
  ActivityGridComponent,
  ActivityFormComponent,
  JobgroupViewComponent,
  JobgroupFormComponent,
  JobsFormComponent,
  JobsViewComponent,
  StructuresViewComponent,
  StructuresFormComponent,
  StructuresplanningGridComponent,
  StructuresplanningFormComponent,
  BoqitemGridComponent,
  BoqitemFormComponent,
  MilestoneGridComponent,
  MilestoneFormComponent,
  PhasescheduleFormComponent,
  PhasescheduleGridComponent,
  ContractorGridComponent,
  LandpurchaseGridComponent,
  LandpurchaseFormComponent,
  LandacquisitionGridComponent,
  LandacquisitionFormComponent,
  ContractorFormComponent,
  ContractordocGridComponent,
  ContractordocFormComponent,
  DocTypeGridComponent,
  DocTypeFormComponent,
  EncumbrancesTypeGridComponent,
  EncumbrancesTypeFormComponent,
  EncumbrancesFormComponent,
  EncumbrancesGridComponent,
  QuantumGridComponent,
  QuantumFormComponent,
  DesignIssueFormComponent,
  DesignIssueGridComponent,
  DesignIssueTypeGridComponent,
  DesignIssueTypeFormComponent,
  ScheduleExtensionGridComponent,
  ScheduleExtensionFormComponent,
  ProjectProgressGridComponent,
  ProjectProgressFormComponent,
  ProjectDesignIssueAllGridComponent,
  ProjectDesignIssueAllFormComponent,
  PescGridComponent,
  PescFormComponent,
  PescTypeFormComponent,
  PescTypeGridComponent,
  QcTypeGridComponent,
  QcTypeFormComponent,
  QcFormComponent,
  QcGridComponent,
  AdvocatesGridComponent,
  AdvPayGridComponent,
  AdvPayFormComponent,
  StatusviewComponent,
  ApplicationcancellationComponent,
  ApplicationinstallmentpayComponent,
  AppstatusComponent,
  TransactionDetailsComponent,
  QueryComponent,
  CavGridComponent,
  CavFormComponent,
  FmGridComponent,
  FmFormComponent,
  CasetypeGridComponent,
  CasetypeFormComponent,
  ApplicationrefundComponent,
  FilemasterGridComponent,
  FilemasterFormComponent,
  auctionintimationComponent,
  auctionnotificationComponent,
  NotAllotedRefundFormComponent,
  KhbInstachallanComponent,
  LotteryApplicantViewComponent,
  //HRMS Imports start
  CasteGridComponent,
  CasteFormComponent,
  DesignationFormComponent,
  DesignationGridComponent,
  ReligionGridComponent,
  ReligionFormComponent,
  ScalesFormComponent,
  ScalesGridComponent,
  SalaryGridComponent,
  SalaryFormComponent,
  LeavesFormComponent,
  LeavesGridComponent,
  UserprofileGridComponent,
  UserprofileFormComponent,
  HolidaycalendarFormComponent,
  HolidaycalendarGridComponent,
  EmpBasicDetailGridComponent,
  EmpBasicDetailFormComponent,
  DependentGridComponent,
  DependentFormComponent,
  QualificationInputGridComponent,
  QualificationInputFormComponent,
  LeaveDetailsGridComponent,
  LeaveDetailsFormComponent,
  TrainingDetailsGridComponent,
  TrainingDetailsFormComponent,
  DepartmentalExamDetailsGridComponent,
  DepartmentalExamDetailsFormComponent,
  HtcLtcGridComponent,
  HtcLtcFormComponent,
  DeputationInGridComponent,
  DeputationInFormComponent,
  DeputationOutFormComponent,
  DeputationOutGridComponent,
  BankDetailsGridComponent,
  BankDetailsFormComponent,
  HrmsMenuComponent,
  HrmsComponent,
  ServiceregisterComponent,
  PayrollComponent,
  AllowancesDetailsGridComponent,
  AllowancesDetailsFormComponent,
  AttendanceDetailsFormComponent,
  AttendanceDetailsGridComponent,
  DeductionDetailsGridComponent,
  DeductionDetailsFormComponent,
  InsuranceDetailsFormComponent,
  InsuranceDetailsGridComponent,
  TransferComponent,
  TransferInGridComponent,
  TransferInFormComponent,
  TransferOutFormComponent,
  TransferOutGridComponent,

  //HRMS Imports end

  //Land Procurement Imports starts
  DemandsurveyGridComponent,
  DemandsurveyFormComponent,
  ApprovalFormComponent,
  ApprovalGridComponent,
  RegisterdocFormComponent,
  RegisterdocGridComponent,
  //Land Procurement Imports ends

  //Technical Additional Components Starts
  BillingComponent,
  RaBillFormComponent,
  TenderBillFormComponent,
  BillStatusComponent,
  BillPaymentsFormComponent,
  BillSummaryComponent,
  BillPaybillsFormComponent,
  IssueorderFormComponent,
  MetricsFormComponent,
  TaxFormComponent,
  GlobalDataFormComponent,
  ScheduleFormComponent,
  WorkprogressFormComponent,
  WorkslipStatementComponent,
  DashboardTechComponent,
  ProjectProgressComponent,
  WorktypeGridComponent,
  WorktypeFormComponent,
  MetricsGridComponent,
  ManualLotteryTokenComponent,
  CpCrViewComponent,
  KhbnotificationltrComponent,
  ApplicantQueryComponent,
  DirectAllocationComponent,

  AddBundleComponent,
  GodownComponent,
  GodownMenu,
  AppRetRequestComponent,
  GodownQueryComponent,
  NoticeCancellationComponent,
  NotieLetterComponent,
  OrderLetterComponent,
  BillsToFinanceComponent,  
  GodownReportsComponent,
  BundleReportsComponent,  
  SubmittedAppReportsComponent,
   RequestAppRecordsComponent,
   AllocationReportsComponent, 
   AllotedPropertyListComponent, CancellationReportsComponent, PrAllocatedPropListComponent, PrVacantPropListComponent,
   ReportsComponent,  
VacantCommercialPropertyComponent,
AvailBlockedInterDqCornerComponent,
IntermediateAvailableSitehouseflatsComponent, IntermediateBlockedSitehouseflatsComponent,
DqVacantPropertyComponent,
ClearVacantPropertyComponent,
CornerVacantPropertyComponent ,
DistrictwiseVacantPropertyComponent,
BoardmeetinggridComponent,
BoardmeetingComponent,
BidderViewComponent,
PhaseGridComponent,
PhaseFormComponent,
SchemesGridComponent,
SchemesFormComponent,
offlineapplicationComponent,
ChangeRequestComponent, 
AllotNotallotComponent,
LoginlocComponent,
AllertComponent,
LogGridComponent,
WorkflowAlertComponent,
WorkflowAlertGridComponent,
LandProjectGridComponent,
LandProjectFormComponent,
LandProjectDetailsComponent,
LandTownPlanningGridComponent,
LandTownPlanningFormComponent,
ProjectReceivedLpGridComponent,
ProjectPhaseGridComponent,
ProjectPhaseFormComponent,
ReviseBasePriceComponent,
ReviseBaseGridComponent,
ApplicantPaymentComponent,
ApplicantDetailsUpdateComponent,
OfflineApplicationGridComponent,
SixoneimportlandprocComponent,
LotteryReportComponent,
LpAgreementGridComponent,
LpAgreementFormComponent,
LpPurchaseGridComponent,
LpPurchaseFormComponent,
LpPaymentGridComponent,
LpPaymentFormComponent,
LpProfessionGridComponent,
LpProfessionFormComponent,
JointVentureComponent,
JvAgreementGridComponent,
JvAgreementFormComponent,
JvExceptenceGridComponent,
JvExceptenceFormComponent,
JvPossessionGridComponent,
JvPossessionFormComponent,
ManualLotteryComponent,
UserApplicationViewComponent,
LandProcurementDetailsComponent,
CheckComponent,
ProjectReceivedLpFormComponent,
SaledeedComponent,
RecoveryComponent,
BuildingGridComponent,
BuildingFormComponent,
RateFixationGridComponent,


RateFixationFormComponent,
AgreementsFormComponent,
AgreementsGridComponent,
PaymentReceiptsGridComponent,
PaymentReceiptsFormComponent,
RenewalsGridComponent,
RenewalsFormComponent,
BlockGridComponent,
     BlockFormComponent,
    PropertyGridComponent,
    PropertyFormComponent,
    PaymentChallanFormComponent,
    PaymentChallanGridComponent,
    CustomerGridComponent,
    CustomerFormComponent,
    RecoveryMenuComponent,
    RequestPropertyGridComponent, RequestPropertyFormComponent,
    RecoveryReportGridComponent, RecoveryReportFormComponent, 
    RequestPropertiesComponent, RequestPropertyAppGridComponent,
    RequestPropertyAppFormComponent, AgreementsAppComponent,
    AgreementAppGridComponent, AgreementAppFormComponent,
    PaymentChallAppGridComponent, PaymentChallAppFormComponent,
    PaymentChallApprovalComponent, PaymentReceiptApprovalComponent,
    PaymentReceiptAppGirdComponent, PaymentReceiptAppFormComponent,
    MasterDisplayComponent,HospitalGridComponent,HospitalFormComponent,
    MasterCalendarGridComponent,MasterCalendarFormComponent,
    ServiceRegViewFormComponent, AddressDetailsComponent ,     
    AddressDetailsFormComponent,ExperiencedetailsGridComponent,
    ExperiencedetailsFormComponent,PoliceVerificationGridComponent,
    PoliceVerificationComponent,LeaveBalDetGridComponent,
    LeaveBalDetFormComponent,PayrollMastersComponent,
    AllowanceCodeGridComponent,AllowanceCodeComponent,       
    DeductionCodeGridComponent,DeductionCodeComponent,
    FormulaGridComponent,FormulaFormComponent,
    OrganisationProfileComponent,IncomeTaxGridComponent,
    ProfessionalTaxGridComponent,ProfessionalTaxFormComponent,
    IncomeTaxFormComponent,ControlDataComponent,
    PayMonthlyGridComponent,PayMonthlyFormComponent,
    EmpSalaryDetailsComponent,EmpBasicDetailsGridComponent,
    FixedAllowanceGridComponent,FixedAllowanceFormComponent,
    VariableAllowanceGridComponent,VariableAllowanceFormComponent,
    FixedDeductionGridComponent,VariableDeductionGridComponent,
    VariableDeductionFormComponent,LoanDetFormComponent,
    EmpBasicDetailsFormComponent,PayrollProcessDetailsMenuComponent,
    PayrollPaymonthComponent,MedicalReimburesmentGridComponent ,
    MedicalReimburesmentComponent,MedReimSanctionGridComponent ,
    MedReimSanctionFormComponent,LeaveencashmentGridComponent,
    LeaveencashmentComponent,MedicalReimbursmentRecordsGridComponent,
    MedicalReimbursmentRecordsFormComponent,MedReimAuthorizationComponent,
    HtcLtcAuthComponent,LeaveEncashAuthComponent,LeaveEncashSanctionGridComponent,
    LeaveEncashSanctionFormComponent,LeaveEncashmentRecGridComponent,
    LeaveEncashmentRecFormComponent,DepartmentalExamComponent,
    NominationComponent,NominationApplicationGridComponent,
    NominationApplicationComponent,NominationApprovalGridComponent,
    NominationApprovalFormComponent,NominationSanGridComponent,
    NominationRecGridComponent,DepartEnquiryMenuComponent,
    ComplaintsRegGridComponent,ComplaintsRegFormComponent,
    ShowCaseGridComponent,ShowCaseFormComponent,
    ShowCauseAckGridComponent ,ShowCauseAckFormComponent,
    EnquiryProceedingGridComponent,EnquiryProceedingFormComponent,
    InitiateDepartEnquiryGridComponent,InitiateDepartEnquiryFormComponent,
    ComplaintRegAuthComponent,ComplaintRegAuthFormComponent,
    ScnAuthorizationComponent,ScnAuthorizationFormComponent,
    ScnRemainderComponent,ScnRemainderFormComponent,
    EnquiryCloserGridComponent,EnquiryCloserFormComponent,
    ExternalEnquiryFormComponent,ExternalEnquiryGridComponent,
    ExternalEnquiryClosureGridComponent,ExternalEnquiryClosureFormComponent,
    AttendanceLeavesComponent,DailyAttendanceGridComponent,
    DailyAttendanceFormComponent,DailyAttendanceOutGridComponent,
    DailyAttendanceOutFormComponent,LeaveTypeGridComponent,
    LeaveTypeComponent,LeaveAuthGridComponent,
    LeaveAuthFormComponent,LeaveSanctionGridComponent,
    MonthlyLeaveAttenGridComponent,LeaveSanctionFormComponent,
    TimeRollGenGridComponent,TimeRollGenFormComponent,
    TimeRollApprveGridComponent,TimeRollApprveFormComponent,
    TimeRollSanGridComponent,TimeRollSanFormComponent,
    TimeRollFinGridComponent,TimeRollFinFormComponent,
    TimeRollUnintiGridComponent,TimeRollUnintiFormComponent,
    LeaveCreditComponent,LeavecreditGridComponent ,
    LeaveCreditAuthComponent ,LeaveCreditAuthFormComponent,
    LeaveCreditSanctionGridComponent,LeaveCreditSanctionFormComponent,
    LeaveCreditBulkComponent,LeaveCreditBulkFormComponent,BulkLeaveCreditApprovalComponent ,
    BulkLeaveCreditSanctionComponent,MonthlyAttendanceComponent,MonthlyAttendanceGridComponent,
    PromotionsComponent,PromotionGridComponent,PromotionComponent,PromotionAuthGridComponent,
    PromotionAuthFormComponent,PromotionsSanctionGridComponent,PromotionsSanctionFormComponent,
    IncrementsComponent,GenIncrListGridComponent,GenIncrListComponent,IncrListAuthGridComponent,
    IncrListAuthComponent,IncrementsSanctionGridComponent,IncrementsSanctionFormComponent,
    IncrementPostingGridComponent,IncrementPostingFormComponent,RtiComponent,RtiGridComponent,
    EmployeeSeparationComponent ,EmpRetirementListComponent,EmpSeparationGridComponent,
    EmpSeparationComponent,EmpSepAuthComponent,EmpSepAuthFormComponent,PayrollAttendaceLeaveComponent,
    PayrollProcessPayrollComponent,PayrollFinalizePayrollComponent,PayrollReportsMenuComponent,
    MasterReportsComponent,SummaryReportsComponent,MiscellaneousReportsComponent,VariableAllowdeductionComponent,
    IncometaxParameterComponent,PayrollProcessComponent,PayrollFinalizeComponent,
    PayrollAuthorizeGridComponent,PayrollAuthorizeFormComponent,PayrollSanctionGridComponent,
    PayrollSanctionFormComponent,MonthlyAttDetComponent,TransferAuthorizationGridComponent,TransferAuthorizationFormComponent,
    TransferSanctionGridComponent,TransferSanctionFormComponent,TransferRecordersGridComponent,TransferRecordersFormComponent,
    DeputaionComponent,DeputationAuthorizationComponent,DeputationAuthorizationFormComponent,DeputaionSanctionGridComponent,
    DeputaionSanctionFormComponent,DeputationRecGridComponent,DeputationRecFormComponent,EmployeeClaimsComponent,
    HtcLtcSanctionGridComponent,HtcLtcSanctionFormComponent,HtcLtcRecGridComponent,HtcLtcRecFormComponent,
    TrainingComponent,TrainingApprovalGridComponent,TrainingApprovalFormComponent,TrainingSanctionGridComponent,
    TrainingSanctionFormComponent,TrainingRecordGridComponent,
    DeptExamAuthComponent,DeptExamAuthFormComponent,DeptExamSanctionGridComponent,
    DeptExamSanctionFormComponent,DeptExamRecordGridComponent,
    DeptExamRecordFromComponent,LeavecreditComponent, RequestGridComponent,
    RequestFormComponent,RenewalApprovalGridComponent,RenewalApprovalFormComponent,
    RenewalApprovalComponent,PaymentArrearsGridComponent,PaymentArrearsFormComponent,
    TrainingRecordFromComponent,IncrementdetailsFormComponent,DeptenquirydetailsGridComponent,
    DeptenquirydetailsFormComponent,PromotionPostGridComponent,PromotionPostFormComponent,
    ProListAuthGridComponent,ProListAuthComponent,GenProListGridComponent,GenProListComponent,
    LwfGridComponent,LwfFormComponent,EsiGridComponent,EsiFormComponent,EpfGridComponent,
    EpfFormComponent,FixedDeductionFormComponent,NominationSanctionGridComponent,NominationSanctionFormComponent,
    NominationSanFormComponent,NominationRecFormComponent,IncrementComponent,EmployeeSrViewComponent,
    ComplaintRegSanctionFormComponent,ComplaintRegSanctionGridComponent,ScnSanctionFormComponent,
    ScnSanctionGridComponent,HtcLtcAuthFormComponent,LeaveComponent,LeaveEncashAuthFormComponent,
    MedReimAuthorizationFormComponent,EmpRetirementListFormComponent,IncrementGridComponent,
    IncrementdetailsGridComponent,JoiningdetailsFormComponent,JoiningdetailsGridComponent,MedicalExaminationComponent,
    MedicalExaminationGridComponent,PromotiondetailsFormComponent,PromotiondetailsGridComponent,
    AuctionedPropertiesCancelComponent,ViewAuctionedPpropertiesComponent,
    PaymentFormComponent,CheckoutFormComponent
                            
//Technical Additional Components Ends lakshman
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule,MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    //NgbModule,
    //ToolTipModule,
    // RouterModule.forRoot(appRoutes),
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules
  }),
    NgbModule.forRoot()
  ],
  providers: [UserService, ErrorHandler,AuthGuard,{provide: LocationStrategy, useClass: HashLocationStrategy},
    TitleCasePipe
    // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass:AuthInterceptor,
  //   multi:true
  // }
],
  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts